import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { CustomerBar, CustomerReportOptions } from "./CustomerData";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import { Grid } from "@mui/material";
import ReportDatePicker from "./ReportDatePicker";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function Customer() {
  const breadcrumbPaths = [
    { name: "Reports", url: "", className: "colorGrey fontSemi" },
    { name: "Customer", url: "", className: "colorBlue fontSemi" },
  ];

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock0 marginTopBottom25"
      >
        <Grid item xs={5} md={3}>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid>

        <Grid
          item
          container
          xs={6}
          md={7.5}
          rowspacing={4}
          direction="row"
          justifyContent="end"
          alignItems="center"
        >
          <Grid item>
            <ReportDatePicker date={"2023-08-sep"} />
          </Grid>
        </Grid>
      </Grid>

      <Grid sx={{ marginTop: "15px" }} className="revenueItem">
        {/* <Item sx={12}>
          <div className="reportsChart">
            <div className="chartMinHeight">
              <Bar
                id="revenueChart"
                options={CustomerReportOptions}
                data={CustomerBar}
              />
            </div>
          </div>
        </Item> */}
      </Grid>
    </>
  );
}
